import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AnnouncementService } from '../services/announcement.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { sweetAlert } from 'src/app/utils/swal';
import * as moment from 'moment';
import { imageProcessing } from 'src/app/utils/image-processing-utils';
import { ProTipsServiceService } from 'src/app/component/helping-material/nemt-pro-tips/service/pro-tips-service.service';
import * as _ from 'underscore';


@Component({
  selector: 'app-add-announcement',
  templateUrl: './add-announcement.component.html',
  styleUrls: ['./add-announcement.component.css']
})
export class AddAnnouncementComponent implements OnInit , OnDestroy {

  announcementForm: FormGroup;
  announcementId: any;
  status = "active";
  submitted = false;
  driversList = [];
  user:any;
  constructor(
    private proTips: ProTipsServiceService,
    private driverService : DriversService,
    private sharedDataService : SharedDataService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private announcementService: AnnouncementService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {

    this.activatedRoute.params
      .subscribe((params) => {
        this.announcementId = params["id"];
       
      });


    this.announcementForm = this.fb.group({
      name: ["", Validators.required],
      startTime: ["", Validators.required],
      preStartTime: ["", Validators.required],
      endTime: ["", Validators.required],
      preEndTime: ["", Validators.required],
      status: ['active', Validators.required],
      drivers: ['', Validators.required],
      imageURL: ['', Validators.required],
    });

    this.getUser();

    if (this.announcementId) {
      this.getAnnouncementById();
    }
  }

  getUser() {
    this.sharedDataService.getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          this.getDriverList();
        }
      });
  }

  getAnnouncementById() {
    this.announcementService.getAnnouncementById(this.announcementId).subscribe((data) => {
      if (data) {
        this.announcementForm.patchValue({
          ...data,
          preStartTime : moment(data.startTime),
          startTime : data.startTime,
          preEndTime : moment(data.endTime),
          endTime : data.endTime
        })
      }
    })
  }

  onSubmit() {
    this.submitted = true;
    if(this.announcementForm.invalid){
      return
    }
    const payload = this.announcementForm.value;
    if(this.announcementId){
      this.announcementService.updateAnnouncement(this.announcementId, payload, ).subscribe((data) => {
        if (data) {
          this.router.navigateByUrl('support/announcements')
        }
      })
    }else{
      this.announcementService.saveAnnouncement(payload).subscribe((data) => {
        if (data) {
          this.router.navigateByUrl('support/announcements')
        }
      })
    }
    this.submitted = false
  }

  getDriverList() {
    this.driverService.getDrivers(this.user._id, this.status)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.driversList = data;
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  get form(){
    return this.announcementForm.controls;
  }


  // onDateChange(evt, control: AbstractControl) {
  //   if (evt) {
  //     control.setValue(moment(evt).toISOString());
  //   }
  // }

  setStartTime(event) {
    if (event) {
      this.announcementForm.patchValue({
        startTime: moment(event).tz(this.user.timeZone, true).startOf('day').toISOString()
      });
    }
  }
  setEndTime(event) {
    if (event) {
      this.announcementForm.patchValue({
        endTime: moment(event).tz(this.user.timeZone, true).endOf('day').toISOString()
      });
    }
  }

  async fileProcessing(ImageInput, form) {
    imageProcessing(ImageInput)
      .subscribe(async (result) => {
        const data: any = await this.proTips.changeCoverImage(result.file).toPromise();
        form.setValue(data.location);
      })

  }

  selectAllDrivers(isEnabled) {
    let selectedDrivers = [];
    if (!isEnabled) {
      for (let driver of this.driversList) {
        selectedDrivers.push(driver._id); // Push each driver's ID into the array
      }
      selectedDrivers = _.uniq(selectedDrivers).sort(); // Remove duplicates and sort if necessary
    }
  
    // Update the form with the selected drivers
    this.announcementForm.patchValue({
      drivers: selectedDrivers
    });
  }

  ngOnDestroy() {
    
  }
}
